import cover from "../../../assets/cover.png";
import InsightfulStar from "../../../assets/insightfulStar.svg";
import insightfulStarWhite from "../../../assets/insightfulStarWhite.svg";
import upRightArrow from "../../../assets/up-right-arrow-white.svg";
import { LightingBolt } from "../../../constants/images";
import "./style.css";

export default function HeroSection() {
  return (
    <div className="d-flex justify-content-center hero">
      <div className="commonInlinePadding paddingBlock heroContainer section-container">
        <div className="heroFirst">
          <div className="h1 off-black">
            Built for CPG teams that{" "}
            <span className="moveFastText">Move Fast</span>{" "}
            <img src={LightingBolt} alt="" />
          </div>

          <div className="off-black Caption" style={{ marginTop: "0.625rem" }}>
            RegulateCPG automates every compliance step, so we can spend more
            time innovating and less time filling forms.
          </div>

          <div className="buttonContainer">
            <button
              className="btn btn-primary "
              onClick={() =>
                window.open(
                  "https://connect.regulatecpg.com/regulate-book-a-demo",
                  "_blank"
                )
              }
            >
              Book Demo <div className="btn-icon-container"><img src={upRightArrow} alt="Arrow" /></div>
            </button>

            <button
              className="btn btn-outline-primary buttonText"
              onClick={() =>
                window.open(
                  "https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=7d3b3785-0a66-47b0-b943-2f695b8a7120",
                  "_blank"
                )
              }
            >
              InsightSuite
              <span style={{ fontWeight: "400", marginLeft: "-0.625rem" }}>
                ™
              </span>{" "}
              Demo
              <div className="btn-icon-container"><img src={InsightfulStar} alt="Arrow" className="icon-default" />
                <img
                  src={insightfulStarWhite}
                  alt="Arrow"
                  className="icon-hover"
                /></div>
            </button>
          </div>
        </div>
        <div>
          <video
            className="videoPlayer"
            controls
            poster={cover}
          >
            <source
              src="https://helmsman-static-bucket-development.s3.us-west-1.amazonaws.com/Video/Regulate_Expo_Tutorial_Draft_A.mp4"
              type="video/mp4"
            ></source>
          </video>
        </div>
      </div>
    </div>
  );
}
